//var SirvOptions = { autostart: false };

var $lockMZUpdate = false,
    $firstImageIsVideo = false;

mzOptions = mzOptions || {};
mzOptions.onUpdate = function() {
    if (!$lockMZUpdate) {
        mtHighlightActiveSelector();
    }
    $lockMZUpdate = false;
};
var mtZoomIsReady = false;
mzOptions.onZoomReady = function(id) {
    mtZoomIsReady = true;
    if (!$firstImageIsVideo) {
        mtHighlightActiveSelector();
    }
}

function mtIfZoomReady(fnc) {
    if (!mtZoomIsReady) {
        setTimeout(function() {
            mtIfZoomReady(fnc);
        }, 250);
        return;
    }
    fnc();
}

function mtInitSelectors(selector) {
    jQuery(selector).on((mzOptions && mzOptions.selectorTrigger && mzOptions.selectorTrigger == 'hover') ? 'mouseover click' : 'click touchend', function(e) {

  //console.warn('click', $(this).attr('data-slide-id'))
      
        var el = jQuery(this);
        if (jQuery('.MagicToolboxContainer .MagicToolboxSlide.active-magic-slide iframe').length == 1) {
            jQuery('.MagicToolboxContainer .MagicToolboxSlide.active-magic-slide iframe')[0].src = jQuery('.MagicToolboxContainer .MagicToolboxSlide.active-magic-slide iframe')[0].src;
        }
        jQuery('.MagicToolboxContainer .MagicToolboxSlide').removeClass('active-magic-slide');
        jQuery('.MagicToolboxContainer .MagicToolboxSlide[data-slide-id="' + el.attr('data-slide-id') + '"]').addClass('active-magic-slide');
        jQuery('.MagicToolboxContainer .MagicToolboxSelectorsContainer a').removeClass('active-magic-selector mz-thumb-selected');
        el.addClass('active-magic-selector mz-thumb-selected');
        if (el.attr('data-slide-id') == 'spin') {
            var resizeEvent = window.document.createEvent('UIEvents');
            resizeEvent.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(resizeEvent);
        }
        e.preventDefault();
    });
}

function mtInitVideoSelectors() {

    jQuery('.MagicToolboxSlides div[data-video-url]').each(function() {

        if (jQuery(this).data('processed')) return;

        var regex_youtube_short = /https?:\/\/youtu\.be\/([^\/]{1,})\/?/gm,
            regex_youtube_full = /https?:\/\/www\.youtube\.com\/watch\?v=(.*?)(&|$).*/gm,
            regex_youtube_embed = /https?:\/\/www\.youtube\.com\/embed\/(.{1,})/gm,
            regex_vimeo = /https?:\/\/vimeo\.com\/(.{1,})/gm,
            video_id, video_type;
        var $videoURL = jQuery(this).attr('data-video-url').replace(/https\:\/\/player\.vimeo\.com\/video\/([0-9]{1,})/gm, 'https://vimeo.com/$1');
        var m = regex_youtube_short.exec($videoURL);
        if (m) {
            video_id = m[1];
            video_type = 'youtube';
        } else {
            var m = regex_youtube_full.exec($videoURL);
            if (m) {
                video_id = m[1];
                video_type = 'youtube';
            } else {
                var m = regex_youtube_embed.exec($videoURL);
                if (m) {
                    video_id = m[1];
                    video_type = 'youtube';
                } else {
                    var m = regex_vimeo.exec($videoURL);
                    if (m) {
                        video_id = m[1];
                        video_type = 'vimeo';
                    }
                }
            }
        }
        if (video_type == 'youtube') {
            jQuery(this).html('<div class="magic-video-container"><iframe src="https://www.youtube.com/embed/' + video_id + '" frameborder="0" allowfullscreen></iframe></div>');
        } else if (video_type == 'vimeo') {
            jQuery(this).html('<div class="magic-video-container"><iframe src="https://player.vimeo.com/video/' + video_id + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>');
        } else {
            jQuery('div[data-slide-id="' + jQuery(this).attr('data-slide-id') + '"],a[data-slide-id="' + jQuery(this).attr('data-slide-id') + '"]').remove();
        }
    })
}

function mtHighlightActiveSelector() {
    if (typeof jQuery == 'undefined') {
        return;
    }
    jQuery('.MagicToolboxContainer .MagicToolboxSelectorsContainer a').removeClass('active-magic-selector');
    jQuery('.MagicToolboxContainer .MagicToolboxSelectorsContainer a.mz-thumb-selected').addClass('active-magic-selector');
}

function mtGetMaxSizes() {
    var $maxWidth = $maxHeight = 1;
    jQuery('.MagicToolboxSelectorsContainer a > img').each(function() {
        var img = jQuery(this);
        if (img.is(':visible')) {
            $maxHeight = Math.max($maxHeight, img.height());
            $maxWidth = Math.max($maxWidth, img.width());
        }
    });
    return { 'width': $maxWidth, 'height': $maxHeight };
}

function SirvSKUTransform($sku) {
    if (SirvSpinsPathTransform != '') {
        var re = new RegExp('^' + SirvSpinsPathTransform + '$', 'gmsi');
        return $sku.replace(re, '$1');
    }
    return $sku;
}


function mtInitSirv() {

    if (typeof(SirvID) == 'undefined' || SirvID == '') {
        //initMagicScroll();
        return;
    }

    if (SirvSpinPosition == 'first') {
        //SirvOptions = { autostart: true };
    }

    var sku1 = SirvProductSKU.substring(0,1),
        sku2 = SirvProductSKU.substring(1,2);


	/*var sirv = document.createElement('script');
    sirv.type = 'text/javascript';
    sirv.async = true;
    sirv.src = document.location.protocol.replace('file:', 'http:') + '//';
    sirv.src = document.location.protocol.replace('file:', 'http:') + '//scripts.sirv.com/sirvjs/v3/sirv.js';*/


    var spinURL = document.location.protocol.replace('file:', 'https:') + '//' + SirvID + '.sirv.com/' +
        SirvSpinsPath.replace(/{product\-id}/g, SirvProductID)
            .replace(/{product\-sku}/g, SirvProductSKU)
            .replace(/{product\-sku\-1}/g, sku1)
            .replace(/{product\-sku\-2}/g, sku2)
            .replace(/{vendor}/g, SirvProductVendor)
            .replace(/{product\-name}/g, SirvProductName);

    if (typeof SirvSpinOverrides != 'undefined' && typeof SirvSpinOverrides[SirvProductID+'-'] != 'undefined'&& SirvSpinOverrides[SirvProductID+'-'] != '') {
        spinURL = 'https://' + SirvID + '.sirv.com/' + SirvSpinOverrides[SirvProductID+'-'];
    }

    jQuery.ajax({
        url: spinURL,
        type: 'HEAD',
        cache: true,
        timeout: 4000,
        error: function(jqXHR, textStatus, errorThrown) {
            initMagicScroll();
        },
        success: function(data, textStatus, jqXHR) {
            mtInitSirvIcon(spinURL);
        },
    });

    for (var i in SirvVariants) {
        var $sku = SirvSKUTransform(SirvVariantsSKU[i].sku);
        var v_spinURL = document.location.protocol.replace('file:', 'http:') + '//' + SirvID + '.sirv.com/' +
            SirvSpinsPath
                .replace(/{product\-id}/g, i)
                .replace(/{product\-sku}/g, (typeof SirvVariantsSKU[i].sku != 'undefined' && SirvVariantsSKU[i].sku != '' && SirvVariantsSKU[i].sku != null) ? $sku.replace('/', '') : i)
                .replace(/{product\-sku\-1}/g, sku1)
                .replace(/{product\-sku\-2}/g, sku2)
                .replace(/{vendor}/g, SirvProductVendor)
                .replace(/{product\-name}/g, SirvProductName + '-' + i);

        if (typeof SirvSpinOverrides != 'undefined' && typeof SirvSpinOverrides[SirvProductID+'-' + i] != 'undefined'&& SirvSpinOverrides[SirvProductID+'-' + i] != '') {
            v_spinURL = 'https://' + SirvID + '.sirv.com/' + SirvSpinOverrides[SirvProductID+'-' + i];
        }

        jQuery.ajax({
            url: v_spinURL,
            type: 'HEAD',
            'cache': true,
            timeout: 4000,
            spinID: i,
            error: function() { SirvVariants[this.spinID] = false; },
            success: function(data) {
                SirvVariants[this.spinID] = this.url.replace(/\?callback.*/gm, '');
                if (this.spinID == currentVariantID) {
                    if (SirvSpinPosition == 'first') {
                        mtInitSirvIcon(SirvVariants[this.spinID]);
                        mtShowSirvVariant(currentVariantID)
                    } else {
                        mtInitSirvIcon(SirvVariants[this.spinID]);
                        var $h = (SirvMaxHeight > 0) ? '?h=' + SirvMaxHeight : '';
                        jQuery('.Sirv div').attr('data-src', SirvVariants[this.spinID] + $h);
                    }
                    currentVariantID = 0;
                }
            }
        });
    }

}

function initMagicScroll() {
    if (jQuery('#msc-selectors-container').length) {
        MagicScroll.start();
    }
}

function mtInitArrows() {
    jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').on('click', function(e) {
        var $selectorsContainer = jQuery(this).closest('.MagicToolboxContainer').find('.MagicToolboxSelectorsContainer'),
            $currentSelector = $selectorsContainer.find('a.active-magic-selector'),
            $newSelector = false,
            $useScroll = jQuery('#msc-selectors-container').length,
            $forward = jQuery(this).hasClass('magic-next'),
            $mscItem, $mscCurItemId, $mscNewItemId;

        if ($useScroll) {
            $mscItem = $currentSelector.parent();
            $mscCurItemId = $mscItem.attr('data-item');
            $mscItem = $forward ? $mscItem.next() : $mscItem.prev();
            if (!$mscItem.length) {
                $mscItem = $selectorsContainer.find('div[data-item=' + $mscCurItemId + ']');
                $mscItem = $forward ? $mscItem.first().next() : $mscItem.last().prev();
                if (!$mscItem.length) {
                    //NOTE: carousel, cover-flow
                    $mscItem = $forward ? $selectorsContainer.find('.mcs-item:first') : $selectorsContainer.find('.mcs-item:last');
                    if (!$mscItem.length) {
                        e.preventDefault();
                        return;
                    }
                }
            }
            $newSelector = $mscItem.find('a');
            $mscNewItemId = $mscItem.attr('data-item');
            $mscNewItemId = parseInt($mscNewItemId, 10);
            MagicScroll.jump('msc-selectors-container', $mscNewItemId);
        } else {
          $newSelector = $forward ? $currentSelector.nextAll('a').find(':visible').first() : $currentSelector.prevAll('a').find(':visible').last();
            if (!$newSelector.length) {
              $newSelector = $forward ? $selectorsContainer.find(':visible').first() : $selectorsContainer.find(':visible').last();
            }
        }
      
      if ($newSelector.get(0).tagName == 'IMG' ) {
      $newSelector = $newSelector.closest('a');
      }

      //console.warn($newSelector)
        if ($newSelector.length) {
            $newSelector.trigger('click');
            if ($newSelector.hasClass('mz-thumb')) {
                $lockMZUpdate = true;
              
                MagicZoom.switchTo(jQuery(this).closest('.MagicToolboxContainer').find('a.MagicZoomPlus').attr('id'), $newSelector[0]);
            }
        }
        e.preventDefault();
    });
}

function checkSirvVariant() {
  //console.warn('check for spin')
  if (!SirvVariants[currentVariantID] && typeof SirvVariants[currentVariantID] != 'undefined') {
    //console.warn('hide')
    jQuery('a[data-slide-id="spin"]').hide().removeClass('visible');
    jQuery('div[data-slide-id="spin"]').removeClass('active-magic-slide');
    jQuery('div[data-slide-id="zoom"]').addClass('active-magic-slide');
    
    //$('.mz-thumb-selected, a[data-slide-id="zoom"]').first().trigger('click');
  } else {
    //console.warn('show')
    jQuery('a[data-slide-id="spin"]').show().addClass('visible');
  }
}

function mtInitSirvIcon(spinURL) {

    if (jQuery('div[data-slide-id="spin"]').length) {
        return;
    }

    var $iconClass = '';

    if (SirvIconURL == 'gif-overlay' || SirvIconURL == 'giftwitch-overlay') {
        $iconClass = 'spin-overlay-icon';
    }

    if (SirvIconURL == 'gif' || SirvIconURL == 'gif-overlay') {
        SirvIconURL = spinURL + '?image'
    }
    if (SirvIconURL == 'giftwitch' || SirvIconURL == 'giftwitch-overlay') {
        SirvIconURL = spinURL + '?image.rules=R30L60R30&image.speed=1000&image.pause=3000'
    }

    var $h = (SirvMaxHeight > 0) ? '?h=' + SirvMaxHeight : '';
    jQuery('.MagicToolboxSlides').append(
        '<div data-slide-id="spin" class="MagicToolboxSlide"><div class="Sirv" data-src="' + spinURL + $h + '"></div></div>'
    );

    jQuery('.MagicToolboxContainer').removeClass('no-thumbnails');
    jQuery('.MagicToolboxSelectorsContainer').show();

    jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').show();

    var sizes = mtGetMaxSizes();

    if (jQuery('.MagicToolboxSelectorsContainer a').length == 0) {
        jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').hide();
        jQuery('.MagicToolboxSelectorsContainer').append(
            ' <a class="'+$iconClass+'" data-slide-id="spin" href="#"><img id="SirvIcon"  src="' + SirvIconURL + '"/></a>'
        );
    } else if (SirvSpinPosition == 'last') {
        jQuery('.MagicToolboxSelectorsContainer a:last').after(
            ' <a class="'+$iconClass+'" data-slide-id="spin" href="#"><img id="SirvIcon"  src="' + SirvIconURL + '"/></a>'
        );
    } else if (SirvSpinPosition == 'second') {
        jQuery('.MagicToolboxSelectorsContainer a:first').after(
            ' <a class="'+$iconClass+'" data-slide-id="spin" href="#"><img id="SirvIcon"  src="' + SirvIconURL + '"/></a>'
        );
    } else {
    var $target = jQuery('.MagicToolboxSelectorsContainer a:first');
    var rect = $target.get(0).getBoundingClientRect();

    jQuery('.MagicToolboxSelectorsContainer a:first').before(
        '<a class="'+$iconClass+'" data-slide-id="spin" href="#">' +
            '<img id="SirvIcon4" src="' + SirvIconURL + 
            // '" width="' + rect.height + '" height="' + rect.height + '" />' +
            '" width="' + rect.height + '" height="' + rect.height + '" alt="' + 360 + '" />' +
        '</a>'
    );
}

    if (jQuery('.MagicToolboxContainer').hasClass('layout-bottom')) {
        jQuery('#SirvIcon').css('height', sizes.height + 'px').show();
    } else {
        jQuery('#SirvIcon').css('width', sizes.width + 'px').show();
    }

    mtInitSelectors('.MagicToolboxSelectorsContainer a[data-slide-id="spin"]');

    if (SirvSpinPosition == 'first') {
        if (SirvVariants[currentVariantID]) {
            mtShowSirvVariant(currentVariantID);
            currentVariantID = 0;
        } else {
            jQuery('.MagicToolboxSelectorsContainer a[data-slide-id="spin"]').trigger('click');
        }
    }

    if (jQuery('.MagicToolboxSelectorsContainer a').length == 0) {
        jQuery('.MagicToolboxContainer').addClass('no-thumbnails');
        jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow, .MagicToolboxSelectorsContainer').hide();
        jQuery('div[data-slide-id="zoom"]').removeClass('active-magic-slide');
        jQuery('div[data-slide-id="spin"]').addClass('active-magic-slide');
        //Sirv.start();

    }

    checkSirvVariant();

    initMagicScroll();
}

function mtShowSirvVariant(variant_id) {

    if (typeof SirvVariants[variant_id] == 'undefined') {
        return;
    }

    if (jQuery('#SirvIcon').length == 0) {
        var $useScroll = jQuery('#msc-selectors-container').length;
        if ($useScroll) {
            MagicScroll.stop();
        }
        mtInitSirvIcon(SirvVariants[variant_id]);
    }
    if (typeof Sirv != 'undefined') {
        //Sirv.stop();
    }
    var $h = (SirvMaxHeight > 0) ? '?h=' + SirvMaxHeight : '';
    jQuery('div[data-slide-id="spin"]').html('<div class="Sirv" data-src="' + SirvVariants[variant_id] + $h + '"></div>');
    if (SirvSpinPosition == 'first') {
        jQuery('a[data-slide-id="spin"]').addClass('visible').trigger('click');
    } else {
        jQuery('a.mz-thumb-selected').trigger('click')
    }

    checkSirvVariant()
}

function mtSwitchImage(largeImage, smallImage) {
    var activeSlide = jQuery('.MagicToolboxContainer .active-magic-slide');
    if (activeSlide.attr('data-slide-id') == 'spin') {
        activeSlide.removeClass('active-magic-slide');
        jQuery('.MagicToolboxContainer .MagicToolboxSlide[data-slide-id="zoom"]').addClass('active-magic-slide');
    }
    if (jQuery('.mz-lens').length == 0) {
        mtHighlightActiveSelector();
        jQuery('a.MagicZoomPlus').attr('href', largeImage)
        jQuery('a.MagicZoomPlus img').first().attr('src', smallImage);
    } else {
        MagicZoom.update(jQuery('a.MagicZoomPlus').attr('id'), largeImage, smallImage);
    }
}

window['MagicjQueryTries'] = 0;

function mtOnDomReady(fnc) {
    if (typeof(jQuery) == 'undefined') {
        window['MagicjQueryTries']++;
        if (window['MagicjQueryTries'] == 10) {
            var mt_jq = document.createElement('script');
            mt_jq.type = 'text/javascript';
            mt_jq.async = false;
            mt_jq.src = 'https://code.jquery.com/jquery-2.2.4.min.js';
            document.getElementsByTagName('script')[0].parentNode.appendChild(mt_jq);
        }
        setTimeout(function() {
            mtOnDomReady(fnc);
        }, 50);
        return;
    }
    jQuery(document).ready(fnc);
}


function mtGetParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function mtGetVariantId() {
    // Try to get variant from URL
    var variantId = mtGetParameterByName('variant');
    // If not get variants on product object
    if (!variantId && typeof mt_product != 'undefined' && mt_product.variants && mt_product.variants.length > 0) {
        for (var i = 0; i < mt_product.variants.length; i++) {
            if (mt_product.variants[i].available) {
                variantId = mt_product.variants[i].id;
                break;
            }
        }
    }
    return variantId;
}

function updateMZPGallery($id) {

  //console.warn('updateMZPGallery')
  
    var $s = jQuery('a[data-variants*="' + $id + '"]');
    if ($s.length && Object.keys(SirvVariants).length > 1) {
      
      	MagicZoom.stop();
      	
        $s.show().attr('data-zoom-id', jQuery('.MagicZoomPlus').attr('id') );
        //$s.prevAll().hide();

        jQuery('.MagicToolboxSelectorsContainer a').hide().removeClass('visible').removeAttr('data-zoom-id');

        var $hide = false;

        //var $option_hash = $s.find('img').attr('alt').replace(/.*(#.*)/gm,'$1');
      
      var $option_hash = 'colour_'+SirvVariantsSKU[$id]['option1'].toLowerCase().replace(/[^a-z0-9]/ig,'-').replace(/\-{1,}/ig,'-');
      
      //console.warn($option_hash)

//      jQuery('a[data-variants][title$="'+$option_hash+'"]').show().addClass('visible').attr('data-zoom-id', jQuery('.MagicZoomPlus').attr('id') );
      
      jQuery('.MagicToolboxSelectorsContainer a').each(function(){
        //console.warn($(this).attr('title'))
    	var regex = new RegExp('\#'+$option_hash+'( |$)');
        if ( regex.exec(jQuery(this).attr('title')) ) {
          jQuery(this).show().addClass('visible').attr('data-zoom-id', jQuery('.MagicZoomPlus').attr('id') );
        }
    	var regex = new RegExp('\#all( |$)');
        if ( regex.exec(jQuery(this).attr('title')) ) {
          jQuery(this).show().addClass('visible').attr('data-zoom-id', jQuery('.MagicZoomPlus').attr('id') );
        }
      })
      
      jQuery('.MagicZoomPlus').attr('href', $s.attr('href') )
      jQuery('.MagicZoomPlus').attr('title', $s.attr('title') )
      jQuery('.MagicZoomPlus').attr('data-image', $s.attr('data-image') )
      jQuery('.MagicZoomPlus img').attr('src', $s.attr('data-image') )
      jQuery('.MagicZoomPlus img').attr('alt', $s.attr('title') )


//         $s.nextAll().each(function() {
//             if (jQuery(this).attr('data-variants') != ',') {
//                 $hide = true;
//             }
//             if ($hide) {
//                 jQuery(this).hide();
//             } else {
//                 jQuery(this).show();
//             }
//         })
      
        $mjs(document).jAddEvent('domready', function() {
            MagicZoom.start();
        });
      
        //jQuery('a[data-slide-id*="video"]').show().addClass('visible');

      checkSirvVariant()
      
    } else if (arguments.length==2) {
      	$mjs(document).jAddEvent('domready', function() {
    		MagicZoom.start();
		});
    }
  
  if (jQuery('.MagicToolboxSelectorsContainer a:visible').length==0) {
  	jQuery('.MagicToolboxSlides-arrow').hide();
  }else {
  jQuery('.MagicToolboxSlides-arrow').show();
  }
}

function initmzp() {

    mtInitVideoSelectors('.MagicToolboxSelectorsContainer a');

    mtInitSelectors('.MagicToolboxSelectorsContainer a');

    var $firstVideoSelector = jQuery('[data-slide-num="0"][data-video-url]');
    if ($firstVideoSelector.length) {
        jQuery('a[data-slide-id="' + $firstVideoSelector.attr('data-slide-id') + '"]').trigger('click');
        $firstImageIsVideo = true;
    }

    mtInitSirv();

    mtInitArrows();

  if (typeof currentVariantID != 'undefined')
  {    updateMZPGallery(currentVariantID, true); }
  
  jQuery('.MagicToolboxSelectorsContainer').show();

    jQuery('form[action*="/cart/add"]').on('change', function() {
      
      

        setTimeout(function(){

            var $id = mtGetVariantId();
            updateMZPGallery($id)

            if (typeof currentVariantID == 'undefined' || $id == currentVariantID) return;
            currentVariantID = $id;

            var $s = jQuery('a[data-variants*="' + $id + '"]');
            if (typeof MagicZoom != 'undefined' && $s.length) {
                MagicZoom.update(
                    $s.closest('.MagicToolboxContainer').find('.MagicZoomPlus').attr('id'),
                    $s.attr('href'),
                    $s.attr('data-image')
                )
            }

            if (typeof SirvVariants != 'undefined' && typeof SirvVariants[$id] != 'undefined' && typeof SirvVariants[$id] == 'string') {
                mtShowSirvVariant($id);
            } else {
                $s.trigger('click')
            }

            checkSirvVariant()

        },100)

    })

}

mtOnDomReady(function() {
    initmzp();
});